import type { ICard } from "../../cardsSlice";

export const major5Card: ICard = {
    id: "major_5",
    arcana: "major",
    number: 5,
    suit: "major",
    court: "major",
    name: "Иерофант",
    nameEn: "The Hierophant",
    keywords: ["Традиция", "Наставничество", "Духовное знание"],
    symbolism: [
      "Священник на троне, два послушника",
      "Тройной крест, поднятая рука",
      "Ключи у ног, красно-белая одежда"
    ],
    symbolismInterpretation:
      "Посредник между высшим знанием и земной жизнью; духовный учитель",
    archetype: "Хранитель традиции, духовный авторитет",
    psychology: "Поиск опоры в традиции, стремление к порядку через знание",
    upright: {
      personality: "Консерватизм, следование ценностям",
      relationships: "Официальность, социальное одобрение",
      work: "Обучение, консультирование, работа с системами",
      spirituality: "Следование пути, наставничество",
      examples: ["Обращение к опыту", "Поддержка со стороны", "Духовная опора"]
    },
    reversed: {
      meaning: "Догматизм, слепое следование правилам",
      nuances: "Отказ слушать себя, страх отклонения от нормы"
    },
    associations: ["Учение", "Обряд", "Духовный авторитет", "Институт"],
    combinations: ["С Магом — знание и практика", "С Жрицей — глубокая духовная интеграция"],
    readingTips: ["Смотреть, не ограничивает ли традиция", "Определить, где нужен опыт старших"],
    selfQuestions: ["Какая традиция меня поддерживает?", "Что я могу передать другим?"]
  };


